module.exports = __webpack_public_path__ + "img/no-data.98542ba8.jpg";